import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Logout = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const handleLogout = async () => {
      try {
        // Clear local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        // Show success message
        
        // Redirect based on user type
        if (currentUser?.user?.is_landlord) {
          navigate('/login');
        } else {
          navigate('/');
        }
      } catch (error) {
        console.error('Logout error:', error);
        Swal.fire({
          title: 'Error',
          text: 'Something went wrong during logout',
          icon: 'error',
          confirmButtonColor: '#1a237e'
        });
      }
    };

    handleLogout();
  }, [navigate, currentUser]);

  // Show loading while processing logout
  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)'
    }}>
      <div style={{ 
        color: 'white', 
        fontSize: '1.2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem'
      }}>
        <i className="fas fa-spinner fa-spin fa-2x"></i>
        <span>Logging out...</span>
      </div>
    </div>
  );
};

export default Logout;
